import SphereGeometryLoader from "../../output/assets/geometries/sphere-geometry-loader.js";

class ThreeSphereGeometryLoader extends SphereGeometryLoader {
    constructor() {
        super();
    }

    load(radius, widthSegments, heightSegments) {
        return new THREE.SphereBufferGeometry(radius, widthSegments, heightSegments);
    }

    unload(geometry) {
        geometry.dispose();
    }
}

export default ThreeSphereGeometryLoader;
